import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);

  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await emailjs.sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        "template_623v0ov",
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );
      await emailjs.sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        "template_1efri9u",
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );
      alert("Message sent successfully ✦");
      form.current.reset();
    } catch (error) {
      console.error(error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=Montserrat:wght@500;600&family=Lato:wght@300;400&display=swap');

        .contact-section {
          background-color: #fdf8f0;
          background-image:
            radial-gradient(ellipse at 90% 10%, rgba(130,94,10,0.07) 0%, transparent 50%),
            radial-gradient(ellipse at 10% 90%, rgba(196,138,20,0.05) 0%, transparent 50%);
          padding: 80px 24px 100px;
          position: relative;
        }

        /* Section header */
        .contact-header {
          text-align: center;
          margin-bottom: 52px;
        }
        .contact-badge {
          display: inline-block;
          background: rgba(130,94,10,0.1);
          border: 1px solid rgba(130,94,10,0.25);
          color: #825e0a;
          padding: 5px 16px;
          border-radius: 40px;
          font-size: 11px;
          letter-spacing: 3px;
          text-transform: uppercase;
          font-family: 'Montserrat', sans-serif;
          font-weight: 600;
          margin-bottom: 14px;
        }
        .contact-header h2 {
          font-family: 'Playfair Display', serif;
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 700;
          color: #2c1a00;
          margin: 0 0 0;
        }
        .contact-header h2 span { color: #825e0a; }
        .contact-ornament {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin: 12px auto 0;
        }
        .contact-ornament .co-line {
          height: 1px; width: 50px;
          background: linear-gradient(to right, transparent, rgba(130,94,10,0.35));
        }
        .contact-ornament .co-line-r {
          height: 1px; width: 50px;
          background: linear-gradient(to left, transparent, rgba(130,94,10,0.35));
        }

        /* Grid */
        .contact-container {
          max-width: 1000px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1.4fr;
          gap: 40px;
          align-items: start;
        }
        @media (max-width: 768px) {
          .contact-container { grid-template-columns: 1fr; gap: 32px; }
        }

        /* Left info */
        .contact-info {
          padding: 36px 28px;
          background: linear-gradient(135deg, #2c1a00, #4a2e05);
          border-radius: 14px;
          border: 1px solid rgba(196,138,20,0.15);
        }
        .contact-info-title {
          font-family: 'Playfair Display', serif;
          font-size: 22px;
          font-weight: 700;
          color: #f0c060;
          margin-bottom: 8px;
        }
        .contact-info-sub {
          font-family: 'Lato', sans-serif;
          font-size: 14px;
          color: rgba(253,248,240,0.5);
          font-weight: 300;
          line-height: 1.7;
          margin-bottom: 28px;
        }

        /* Divider */
        .info-divider {
          height: 1px;
          background: rgba(196,138,20,0.15);
          margin-bottom: 24px;
        }

        .info-item {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          margin-bottom: 20px;
        }
        .info-icon {
          width: 36px; height: 36px;
          border-radius: 50%;
          background: rgba(196,138,20,0.12);
          border: 1px solid rgba(196,138,20,0.25);
          display: flex; align-items: center; justify-content: center;
          font-size: 15px;
          flex-shrink: 0;
        }
        .info-text {
          display: flex; flex-direction: column; gap: 2px;
        }
        .info-label {
          font-family: 'Montserrat', sans-serif;
          font-size: 10px;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: rgba(196,138,20,0.6);
          font-weight: 600;
        }
        .info-value {
          font-family: 'Lato', sans-serif;
          font-size: 14px;
          color: rgba(253,248,240,0.75);
          font-weight: 400;
        }

        /* Right form */
        .contact-form-wrap {
          background: #ffffff;
          padding: 36px 32px;
          border-radius: 14px;
          box-shadow: 0 8px 32px rgba(130,94,10,0.1);
          border: 1px solid rgba(130,94,10,0.08);
        }
        .form-title {
          font-family: 'Playfair Display', serif;
          font-size: 20px;
          font-weight: 700;
          color: #2c1a00;
          margin-bottom: 20px;
        }
        .contact-form {
          display: flex;
          flex-direction: column;
          gap: 14px;
        }
        .contact-form input,
        .contact-form textarea {
          padding: 13px 16px;
          border-radius: 8px;
          border: 1px solid rgba(130,94,10,0.2);
          background: #fdf8f0;
          font-size: 14px;
          font-family: 'Lato', sans-serif;
          color: #2c1a00;
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
          outline: none;
        }
        .contact-form input::placeholder,
        .contact-form textarea::placeholder {
          color: rgba(90,61,16,0.4);
        }
        .contact-form input:focus,
        .contact-form textarea:focus {
          border-color: #c48a14;
          box-shadow: 0 0 0 3px rgba(196,138,20,0.1);
        }
        .contact-form textarea { resize: vertical; min-height: 110px; }

        .contact-btn {
          margin-top: 4px;
          padding: 14px;
          background: linear-gradient(135deg, #825e0a, #c48a14);
          color: #fff;
          font-size: 14px;
          font-weight: 600;
          font-family: 'Montserrat', sans-serif;
          letter-spacing: 1px;
          text-transform: uppercase;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          transition: opacity 0.25s ease, transform 0.25s ease, box-shadow 0.25s ease;
          box-shadow: 0 4px 16px rgba(130,94,10,0.25);
          display: flex; align-items: center; justify-content: center; gap: 8px;
        }
        .contact-btn:hover:not(:disabled) {
          opacity: 0.9;
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(130,94,10,0.35);
        }
        .contact-btn:disabled { opacity: 0.7; cursor: not-allowed; }

        @keyframes spin { to { transform: rotate(360deg); } }
        .loading-spinner {
          width: 16px; height: 16px;
          border: 2px solid rgba(255,255,255,0.4);
          border-top-color: #fff;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
          display: inline-block;
        }
      `}</style>

      <section className="contact-section" id="contact">

        {/* Header */}
        <div className="contact-header">
          <div className="contact-badge">✦ Get In Touch</div>
          <h2>Let's Begin Your <span>Journey</span></h2>
          <div className="contact-ornament">
            <div className="co-line-r" />
            <span style={{ color: '#825e0a', fontSize: '14px' }}>✦</span>
            <div className="co-line" />
          </div>
        </div>

        <div className="contact-container">

          {/* Left */}
          <div className="contact-info">
            <div className="contact-info-title">We're Here to Help</div>
            <div className="contact-info-sub">
              Reach out for Vastu, Astrology, Numerology or any other guidance. We'll get back to you shortly.
            </div>
            <div className="info-divider" />
            <div className="info-item">
              <div className="info-icon">📍</div>
              <div className="info-text">
                <span className="info-label">Location</span>
                <span className="info-value">Bihar India</span>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon">📞</div>
              <div className="info-text">
                <span className="info-label">Phone</span>
                <span className="info-value">+91 9122397324</span>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon">✉️</div>
              <div className="info-text">
                <span className="info-label">Email</span>
                <span className="info-value">tarunkrgupta.ssp@gmail.com</span>
              </div>
            </div>
          </div>

          {/* Right */}
          <div className="contact-form-wrap">
            <div className="form-title">Send a Message</div>
            <form ref={form} onSubmit={sendEmail} className="contact-form">
              <input type="text"  name="name"    placeholder="Your Name"    required />
              <input type="email" name="email"   placeholder="Your Email"   required />
              <input type="tel"   name="phone"   placeholder="Your Phone"   />
              <textarea           name="message" placeholder="Your Message" required />
              <button type="submit" className="contact-btn" disabled={loading}>
                {loading
                  ? <><span className="loading-spinner" /> Sending…</>
                  : "Send Message ✦"
                }
              </button>
            </form>
          </div>

        </div>
      </section>
    </>
  );
};

export default Contact;